import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { OidcSignupCompleteRequest } from '@ridango/core';
import { Observable } from 'rxjs';
import * as OidcSignupActions from './oidc-signup.actions';
import * as OidcSignupSelectors from './oidc-signup.selectors';

@Injectable()
export class OidcSignupFacade {
    loading$: Observable<boolean> = this.store.select(OidcSignupSelectors.getOidcSignupLoading);
    done$: Observable<boolean> = this.store.select(OidcSignupSelectors.getOidcSignupDone);
    error$: Observable<any> = this.store.select(OidcSignupSelectors.getOidcSignupError);

    constructor(private store: Store) {}

    completeSignup(payload: OidcSignupCompleteRequest) {
        this.store.dispatch(OidcSignupActions.completeSignup({ payload }));
    }

    reset() {
        this.store.dispatch(OidcSignupActions.completeSignupReset());
    }
}
